export enum CurrencyIsoCode {
  KRW = "KRW",
  USD = "USD",
  JPY = "JPY",
  // EU(유로존)/GB Fixed price 용. 상품 가격은 `ShopProduct.euPrice`/`gbPrice`(usPrice 패턴).
  // 적용 국가 판정은 `CountryUtils.convertCountryCodeToCurrency` + `EUROZONE_COUNTRY_CODES`.
  EUR = "EUR",
  GBP = "GBP",
}

export enum CountryCode {
  KR = "KR",
  JP = "JP",
}

export enum ShippingTier {
  Ground = "Ground",
  Air = "Air",
}

export enum Stage {
  Shipping = "shipping",
  Review = "review",
  Payment = "payment",
  Success = "success",
  Fail = "fail",
}

export enum Paygate {
  Paypal = "paypal",
  Inicis = "inicis",
}

export enum PaypalError {
  DetectedPopupClose = "Detected popup close",
}

export enum EnglishCountryName {
  Korea = "Republic of Korea",
  Japan = "Japan",
}

export enum OrderState {
  OrderPlaced = "orderPlaced",
  Packing = "packing",
  Shipped = "shipped",
  Delivered = "delivered",
  OrderCancelled = "orderCancelled",
  ReturnRequested = "returnRequested",
}
